import { Component, Input, Output, EventEmitter, inject, OnChanges, SimpleChanges } from "@angular/core"
import { CommonModule } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { MatCardModule } from "@angular/material/card"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatSelectModule } from "@angular/material/select"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
import  { Station } from "../../models/station.model"
import { sortStationsByName } from "../../utils/station-sort"
import { StationContextService } from "../../services/station-context.service"

@Component({
  selector: "app-station-header",
  standalone: true,
  imports: [CommonModule, FormsModule, MatCardModule, MatFormFieldModule, MatSelectModule, MatProgressSpinnerModule],
  templateUrl: "./station-header.component.html",
  styleUrls: ["./station-header.component.css"],
})
export class StationHeaderComponent implements OnChanges {
  @Input() stations: Station[] = []
  @Input() selectedStation: Station | null = null
  @Input() loading = false
  @Input() title = "Select Station"
  @Input() subtitle = "Choose a station to manage"

  @Output() stationChange = new EventEmitter<Station>()

  private stationContext = inject(StationContextService)

  ngOnChanges(changes: SimpleChanges): void {
    const station = changes["selectedStation"]?.currentValue as Station | null | undefined
    if (station?.id != null) {
      this.stationContext.setActiveStation(station.id)
    }
  }

  onStationChange(station: Station) {
    this.stationContext.setActiveStation(station.id)
    this.stationChange.emit(station)
  }

  compareStations(s1: Station, s2: Station): boolean {
    return s1 && s2 ? s1.id === s2.id : s1 === s2
  }

  get sortedStations(): Station[] {
    return sortStationsByName(this.stations)
  }
}
